import { render, staticRenderFns } from "./UpsertShipment.vue?vue&type=template&id=91a19c88&scoped=true&"
import script from "./UpsertShipment.vue?vue&type=script&lang=js&"
export * from "./UpsertShipment.vue?vue&type=script&lang=js&"
import style0 from "./UpsertShipment.vue?vue&type=style&index=0&id=91a19c88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a19c88",
  null
  
)

export default component.exports